import { formatTimestamp } from '../lib/utils';

interface TimestampDisplayProps {
  value: number | Date | string | null | undefined;
  className?: string;
}

export const TimestampDisplay = ({ value, className = '' }: TimestampDisplayProps) => {
  const { utc, local } = formatTimestamp(value);

  if (!(utc || local)) return <span className={className}>N/A</span>;
  if (!local) return <span className={className}>{utc}</span>;

  return (
    <span className={className}>
      {utc} (<strong className="text-white">{local} local</strong>)
    </span>
  );
};
